import angular from "angular";

angular.module("topline.services", []);
angular.module("indeterminateCheckbox", []);
angular.module("topline.directives", []);
angular.module("topline.components", []);
angular.module("topline.modules", []);
angular.module("topline.filters", []);
angular.module("topline.config", []);
angular.module("topline.chamferForecast", []);
angular.module("gridValueEditor", []);
angular.module("templates", []);

const libraries = [
    "pascalprecht.translate",
    "ngCookies",
    "tmh.dynamicLocale",
    "ngResource",
    "chart.js",
    "ngMessages",
    "ui.router",
    "ui.bootstrap",
    "ui.tree",
    "ui.select",
    "toastr",
    "InterflowErrors",
    "CrossMessageCommunication.module",
    "Locale.module",
    "cgBusy",
    "mgo-angular-wizard",
    "xeditable",
    "rzModule",
    "indeterminateCheckbox",
    "ngFileSaver",
    "ngFileUpload",
    "agGrid"
];

const toplineModules = [
    "gridValueEditor",
    "templates",
    "topline.services",
    "topline.directives",
    "topline.components",
    "topline.modules",
    "topline.config",
    "topline.filters",
    "topline.chamferForecast",
    "gridValueEditor"
];

angular.module("topline.app", [...libraries, ...toplineModules]);
